import { Icon } from "@iconify-icon/react";
import { useTranslation } from "react-i18next";

import { LessonHost } from "@/features/calendar/types/create-slot.ts";
import AppLogoIcon from "@/components/LogoIcon.tsx";
import PATHS from "@/routes/paths.ts";
import useUserStore from "@/features/auth/store/useUserStore.ts";

export interface HostingOption {
  id: LessonHost;
  title: string;
  description: string;
  icon: React.ReactNode;
  className?: string;
  disabled?: boolean;
  hint?: {
    title: string;
    description: string;
    actionLabel: string;
    actionHref: string;
  };
}

export const useHostingOptions = () => {
  const { t } = useTranslation(["forms", "calendar", "common"]);
  const { user } = useUserStore();

  const isGoogleCalendarHealthy = user?.specialRoleChecks.google_calendar === "connected_healthy";

  return [
    {
      id: LessonHost.Ximly,
      title: t("forms:hostMethodSelector.ximly.title"),
      description: t("forms:hostMethodSelector.ximly.description"),
      icon: <AppLogoIcon className="h-full w-full" />,
      className: "",
    },
    {
      id: LessonHost.GoogleMeets,
      title: t("forms:hostMethodSelector.googleMeets.title"),
      description: t("forms:hostMethodSelector.googleMeets.description"),
      icon: <Icon height={"100%"} icon={"logos:google-meet"} width={"100%"} />,
      className: "",
      disabled: !isGoogleCalendarHealthy,
      hint: !isGoogleCalendarHealthy
        ? {
            title: t("calendar:hostingUnavailableIntegrationTitle"),
            description: t("calendar:hostingUnavailableIntegrationDescription"),
            actionLabel: t("calendar:hostingUnavailableIntegrationAction"),
            actionHref: PATHS.TUTOR.SCHEDULE.SETTINGS,
          }
        : undefined,
    },
    {
      id: LessonHost.Zoom,
      title: t("forms:hostMethodSelector.zoom.title"),
      description: t("forms:hostMethodSelector.zoom.description"),
      icon: <Icon height={"100%"} icon={"logos:zoom"} width={"100%"} />,
      className: "",
    },
    {
      id: LessonHost.OtherWay,
      title: t("forms:hostMethodSelector.otherWay.title"),
      description: t("forms:hostMethodSelector.otherWay.description"),
      icon: <Icon height={"100%"} icon={"ph:globe"} width={"100%"} />,
      className: "col-span-2",
    },
  ];
};
